import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { ClientConfigService } from 'src/app/common/services/client-config.service';

export class FunctionsService {    
    constructor(private _location: Location, private _http: HttpClient) {}        

    goBack() {
        this._location.back();
    }
        
    async getClientIpAsync(): Promise<{ ip: string }> {
        let clientIp;

        await this._http.get<{ ip: string }>('https://jsonip.com').toPromise().then(resp => {
            clientIp = resp;
        }).catch(err => {
            clientIp.ip = '';
        });

        return clientIp;
    }

    deepCopy<T>(obj: T): T {
        return JSON.parse(JSON.stringify(obj));
    }

    copyToClipboard(value: string) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = value;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
    }

    getSubtractionForAppHeight(withAppMenu: boolean): number {
        return withAppMenu ? 102 : 66;
    }

    isNullOrUndefined(value: object): boolean {
        return (value === null || value === undefined) ? true : false;
    }
}

export const ClientConfigFactory = () => {
    const clientConfig = new ClientConfigService();

    const browserWindow = window || {};
    const configuration = browserWindow['__configuration'] || {};
    const appEncryptConfig = browserWindow['__appEncryptConfig'] || {};

    for (const key in configuration) {
        if (configuration.hasOwnProperty(key))               
            clientConfig.Configuration[key] = window['__configuration'][key];
    }

    for (const key in appEncryptConfig) {
        if (appEncryptConfig.hasOwnProperty(key))
            clientConfig.AppEncryptConfig[key] = window['__appEncryptConfig'][key];
    }
        
    return clientConfig;
}

/*
- once you login then, the url will be www.ultrarss.com/home from www.ultrarss.com by appending home. then let's say user refresh the page 
  from browser, the 404 error will be generated due to the url www.ultrarss.com/home. if it's without home, it's OK.

  
- item card arrange issue with less than or equal to 3 item cards reamined in grid display mode.
- getting the below error time to time. need more detail log data to address the issue.
    {Status: 1, Message: "The user is not validated in the system: 'eunae@ultrarss.com'.", TotalDataCount: 0, Result: {…}}
    Message: "The user is not validated in the system: 'eunae@ultrarss.com'."
    Result:
    Message: ""
    Method: "UserController.GetAuthToken"
    OccurredDate: "2020-12-14T23:22:11.9405714-06:00"
    transactionId: "1f31e117-9235-4691-bca3-85adb005d6e9"
    __proto__: Object
    Status: 1
    TotalDataCount: 0
    __proto__: Object
- add initial focus for input field - only edit-category component has an issue.
*/